import { render, staticRenderFns } from "./datalist.vue?vue&type=template&id=556efc64&scoped=true&"
import script from "./datalist.vue?vue&type=script&lang=js&"
export * from "./datalist.vue?vue&type=script&lang=js&"
import style0 from "./datalist.vue?vue&type=style&index=0&id=556efc64&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556efc64",
  null
  
)

export default component.exports